import React, { useState } from "react";
import { ChatResponse, IPGeolocation, User } from "../api/models";
import { chatAxios } from "../axios/chatAxios";

export enum Brand {
  CLO3D = "CLO3D",
  CLOSET = "CLOSET",
  CLOSET_CONNECT = "CLOSET_CONNECT",
  MD = "MD",
  ALLINONE = "ALLINONE",
}

export enum Page {
  HOME = "HOME",
  CHAT = "CHAT",
  DASHBOARD = "DASHBOARD",
}

export enum Locale {
  // Use ISO 639 language codes
  English = "en-us",
  Korean = "ko-kr",
  Chinese = "zh-cn",
  Japanese = "ja-jp",
  Spanish = "es-es",
  Portuguese = "pt-br",
  French = "fr-fr",
}

export type Answers = [user: string, response: ChatResponse, brand: Brand];

type AppContextType = {
  theme: string;
  setTheme: React.Dispatch<React.SetStateAction<string>>;
  brand: Brand;
  setBrand: React.Dispatch<React.SetStateAction<Brand>>;
  locale: Locale;
  setLocale: React.Dispatch<React.SetStateAction<Locale>>;
  ipGeoLocation: IPGeolocation;
  setIPGeoLocation: React.Dispatch<React.SetStateAction<IPGeolocation>>;
  top: number;
  setTop: React.Dispatch<React.SetStateAction<number>>;
};

type AppProviderType = {
  children: React.ReactNode;
};

export const AppContext = React.createContext<AppContextType>(
  {} as AppContextType,
);

const AppProvider = ({ children }: AppProviderType) => {
  const [theme, setTheme] = useState<string>("light");
  const [brand, setBrand] = useState(Brand.CLO3D);
  const [locale, setLocale] = useState<Locale>(Locale.English);
  const [ipGeoLocation, setIPGeoLocation] = useState<IPGeolocation>(
    {} as IPGeolocation,
  );
  // Top Retrieved Documents
  const [top, setTop] = useState(6);

  const value = {
    theme,
    setTheme,
    brand,
    setBrand,
    locale,
    setLocale,
    ipGeoLocation,
    setIPGeoLocation,
    top,
    setTop,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export default AppProvider;
